import styled from "styled-components";
export const HotelInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  .hotel-info {
    &-img {
      padding-right: 10px;
      img {
        height: 64px;
        width: 64px;
        border-radius: 4px;
      }
    }
    &-details {
      display: flex;
      flex-direction: column;
    }
    &-rate {
      font-size: 11px;
    }
    &-name {
      font-size: 16px;
      color: #005fc3;
      font-weight: 900;
      font-family: "avenir";
      &-meal {
        color: #0eb381;
        font-weight: normal;
      }
    }
    &-location {
      color: #313e55;
      font-size: 13px;
    }
    &-more-details {
      color: #005fc3;
      font-size: 12px;
      cursor: pointer;
    }
  }
`;
export const HotelFullInfoWrapper = styled.div`
  margin: 12px auto 20px;
  max-width: 1200px;
  width: 100%;
  .hotel-full-info {
    &-card {
      background: #fff;
      border: 1px solid var(--pou-card-border, #e2e5ed);
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 6px 18px rgba(15, 44, 92, 0.08);
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
      box-sizing: border-box;
    }
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
      flex-wrap: wrap;
    }
    &-title {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    &-rate {
      color: #f5c400;
      .ant-rate-star-first,
      .ant-rate-star-second {
        color: #f5c400;
      }
    }
    &-name {
      font-size: 22px;
      color: var(--pou-text-main, #202634);
      font-weight: 800;
      margin: 0;
      line-height: 1.2;
    }
    &-location {
      color: var(--pou-text-muted, #6d7280);
      font-size: 14px;
      font-weight: 500;
    }
    &-gallery {
      border-radius: 10px;
      overflow: hidden;
      .image-gallery {
        box-shadow: none;
        width: 100%;
      }
      img {
        object-fit: cover;
        width: 100%;
        height: auto;
      }
    }
    &-description {
      color: var(--pou-text-main, #202634);
      font-size: 14px;
      line-height: 1.6;
    }
  }
  @media (max-width: 600px) {
    .hotel-full-info {
      &-card {
        padding: 16px;
      }
      &-header {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
`;
export const HotelItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr 210px;
  gap: 16px;
  margin-bottom: 16px;
  width: 100%;
  background-color: var(--pou-card-bg, #fff);
  border: 1px solid var(--pou-card-border, #e2e5ed);
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 4px 10px rgba(15, 44, 92, 0.04);
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
  &.on-request {
    border-color: var(--pou-accent-blue, #0057ff);
  }
  &.no-price {
    grid-template-columns: 280px 1fr;
  }
  &:hover {
    border-color: #c8cddd;
    box-shadow: 0 10px 24px rgba(15, 44, 92, 0.08);
    transform: translateY(-2px);
  }
  .hotel-item {
    &-image {
      border-radius: 8px;
      overflow: hidden;
      height: 180px;
      .image-gallery,
      .image-gallery-slide-wrapper,
      .image-gallery-swipe {
        height: 100%;
      }
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    &-body {
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      gap: 6px;
      align-items: flex-start;
    }
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 6px;
    }
    &-name-row {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: nowrap;
    }
    &-name {
      font-size: 20px;
      color: var(--pou-accent-blue, #0057ff);
      font-weight: 700;
      margin: 0;
      line-height: 1.2;
      &:hover {
        text-decoration: underline;
      }
    }
    &-stars {
      color: #f5c400;
      white-space: nowrap;
      .ant-rate-star-first,
      .ant-rate-star-second {
        color: #f5c400;
      }
    }
    &-location {
      font-size: 14px;
      color: var(--pou-text-muted, #6d7280);
      font-weight: 500;
      margin-top: 2px;
      margin-bottom: 6px;
    }
    &-day-extras {
      font-size: 12px;
      color: #0a72d8;
      margin-top: 4px;
      .day-extra {
        line-height: 1.4;
        margin-top: 4px;
      }
    }
    &-early-discount {
      font-size: 13px;
      font-weight: 700;
      margin-top: 4px;
      background: #0a72d8;
      color: #fff;
      border-radius: 8px;
      padding: 4px 14px;
      min-width: 220px;
    }
    &-notice {
      font-size: 14px;
      line-height: 1.5;
      font-weight: 600;
      margin-top: 8px;
      margin-bottom: 14px;
      &.warning {
        color: var(--pou-warning-red, #d93025);
      }
      &.info {
        color: var(--pou-accent-blue, #0057ff);
      }
    }
    &-price-column {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;
      padding: 6px 0;
      gap: 12px;
      text-align: right;
      align-self: center;
      .price-amounts {
        display: flex;
        gap: 10px;
        align-items: center;
      }
      .price-amount {
        font-size: 22px;
        font-weight: 800;
        color: var(--pou-text-main, #202634);
        &.selling {
          font-size: 14px;
          font-weight: 700;
          color: var(--pou-warning-red, #d93025);
          text-decoration: line-through;
          text-decoration-color: #d93025;
        }
      }
      .price-meta {
        font-size: 12px;
        color: var(--pou-text-muted, #6d7280);
      }
      .price-cta {
        width: 100%;
        height: 36px;
        border-radius: 6px;
        font-weight: 700;
        background-color: var(--pou-accent-blue, #0057ff);
        border-color: var(--pou-accent-blue, #0057ff);
        &:hover,
        &:focus {
          background-color: #0046d0;
          border-color: #0046d0;
        }
        &.secondary {
          background: #fff;
          color: var(--pou-accent-blue, #0057ff);
          border: 1px solid var(--pou-accent-blue, #0057ff);
        }
      }
      .on-request-cta {
        margin-top: 6px;
        background: #fff;
        color: var(--pou-accent-blue, #0057ff);
        border: 1px solid var(--pou-accent-blue, #0057ff);
      }
      .price-promo-image {
        width: 170px;
        max-width: 100%;
        height: auto;
        display: block;
      }
    }
    &-suggestions {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      margin-top: 8px;
    }
    &-suggestion-box {
      border: 1px solid var(--pou-accent-blue, #0057ff);
      border-radius: 8px;
      padding: 12px 14px;
      min-width: 220px;
      max-width: 240px;
      cursor: pointer;
      background: #fff;
      transition:
        box-shadow 0.2s ease,
        transform 0.2s ease;
      &:hover {
        box-shadow: 0 10px 20px rgba(10, 87, 255, 0.14);
        transform: translateY(-2px);
        border-color: #0046d0;
      }
      .suggestion-dates {
        font-weight: 700;
        color: var(--pou-text-main, #202634);
        font-size: 13px;
      }
      .suggestion-meta {
        font-size: 13px;
        color: var(--pou-text-muted, #6d7280);
        margin-top: 2px;
      }
      .suggestion-meals {
        font-size: 12px;
        color: var(--pou-available-green, #2e9b4e);
        font-weight: 600;
        margin-top: 4px;
      }
      .suggestion-price {
        margin-top: 6px;
        font-weight: 700;
        color: var(--pou-text-main, #202634);
        font-size: 13px;
        .suggestion-price-row {
          display: flex;
          align-items: baseline;
          gap: 6px;
          flex-wrap: wrap;
        }
        .price-amounts {
          display: flex;
          gap: 8px;
          align-items: baseline;
          flex-wrap: wrap;
        }
        .price-amount {
          font-size: 16px;
          font-weight: 800;
          color: var(--pou-text-main, #202634);
          &.selling {
            font-size: 12px;
            font-weight: 700;
            color: var(--pou-warning-red, #d93025);
            text-decoration: line-through;
            text-decoration-color: #d93025;
          }
        }
      }
      .suggestion-status {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 700;
        border-radius: 999px;
        padding: 4px 10px;
        text-align: center;
        display: inline-block;
        min-width: 90px;
        &.on-request {
          background: var(--pou-accent-blue, #0057ff);
          color: #fff;
        }
        &.available {
          background: var(--pou-available-green, #2e9b4e);
          color: #fff;
        }
      }
    }
    &-meta {
      display: flex;
      flex-direction: column;
      gap: 2px;
      margin-top: 2px;
      color: var(--pou-text-main, #202634);
      font-size: 14px;
      align-items: flex-start;
      .meta-muted {
        color: var(--pou-available-green, #2e9b4e);
        font-size: 13px;
      }
      .meta-highlight {
        color: var(--pou-warning-red, #d93025);
        font-weight: 500;
      }
    }
    &-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      color: #9aa0ae;
      font-size: 18px;
      .action-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;
        transition:
          color 0.2s ease,
          background-color 0.2s ease;
        &:hover {
          color: var(--pou-accent-blue, #0057ff);
          background: rgba(0, 87, 255, 0.08);
        }
        &.is-favorite {
          color: var(--pou-accent-blue, #0057ff);
        }
      }
    }
    &-date-line {
      margin-top: 6px;
      font-size: 13px;
      color: var(--pou-text-muted, #6d7280);
    }
  }
  @media (max-width: 1100px) {
    grid-template-columns: 260px 1fr 190px;
    &.no-price {
      grid-template-columns: 240px 1fr;
    }
  }
  @media (max-width: 600px) {
    &.no-price {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    padding: 14px;
    .hotel-item-image {
      height: 210px;
    }
    .hotel-item-price-column {
      align-items: flex-start;
      text-align: left;
      width: 100%;
    }
  }
  @media (max-width: 600px) {
    .hotel-item-suggestions {
      flex-direction: column;
    }
    .hotel-item-suggestion-box {
      min-width: 100%;
      max-width: 100%;
    }
  }
`;
export const HotelFilterWrapper = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  .package-filter {
    &-header {
      color: #005fc3;
      font-size: 14px;
      font-weight: 700;
      padding: 15px;
      font-family: "Roboto";
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-body {
      flex: 1;
      padding: 0 14px 16px;
      overflow: auto;
    }
    &-footer {
      display: none;
      padding: 12px 14px 16px;
    }
    &-close-btn {
      height: 42px;
      border-radius: 8px;
      font-weight: 700;
    }
    &-form {
      border: 1px solid #dbe4eb;
      overflow-y: auto;
      height: 100%;
    }
  }
  .ant-form-item {
    margin-bottom: 5px;
  }
  .package-filter-collapse {
    background-color: #fff;
    .ant-collapse-header {
      color: #0c3d71;
      font-size: 14px;
      font-weight: 700;
      font-family: "Avenir";
    }
  }

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    &-item {
      font-size: 14px;
      padding-bottom: 5px;
      margin-bottom: 5px;
      border-bottom: 1px solid #f9f9f9;
    }
  }
  @media (max-width: 1200px) {
    .package-filter-footer {
      display: block;
    }
  }
`;

export const HotelSearchAvailabilityWrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 12px auto;
  background-color: #ffffff;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid var(--pou-border-light, #d8d8d8);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);

  .hotel-search-form {
    margin: 0;
  }

  .search-row {
    display: flex;
    align-items: stretch;
    gap: 10px;
    flex-wrap: nowrap;
    @media (max-width: 900px) {
      flex-wrap: wrap;
    }
  }

  .ant-form-item {
    margin: 0;
  }
  .ant-form-item-label {
    display: none;
  }

  .input-shell {
    flex: 1;
    min-width: 200px;
    height: 46px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: #ffffff;
    border: 1px solid var(--pou-border-light, #d8d8d8);
    border-radius: 6px;
    padding: 0 12px;
    box-shadow: none;
  }

  .input-shell .ant-picker {
    border: none;
    box-shadow: none;
    padding: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    align-items: center;
  }
  .input-shell .ant-picker-input > input {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
  }
  .input-shell .ant-picker-separator,
  .input-shell .ant-picker-suffix {
    color: #111827;
  }
  .input-shell .ant-picker-focused {
    box-shadow: none !important;
  }

  .date-shell {
    gap: 14px;
  }

  .date-grid {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  .date-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .date-divider {
    width: 1px;
    height: 28px;
    background: #e5e7eb;
  }

  .date-shell .ant-picker {
    width: 100%;
    padding: 0;
  }

  .date-shell .ant-picker-input > input {
    font-size: 13px;
    font-weight: 500;
  }

  .hotel-date-popup .ant-picker-panel-container,
  .hotel-range-popup .ant-picker-panel-container {
    border-radius: 14px;
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.2);
  }
  .hotel-date-popup .ant-picker-cell-in-view .ant-picker-cell-inner,
  .hotel-range-popup .ant-picker-cell-in-view .ant-picker-cell-inner {
    border-radius: 10px;
  }
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-selected
    .ant-picker-cell-inner,
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-range-start
    .ant-picker-cell-inner,
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-range-end
    .ant-picker-cell-inner,
  .hotel-range-popup
    .ant-picker-cell-in-view.ant-picker-cell-selected
    .ant-picker-cell-inner,
  .hotel-range-popup
    .ant-picker-cell-in-view.ant-picker-cell-range-start
    .ant-picker-cell-inner,
  .hotel-range-popup
    .ant-picker-cell-in-view.ant-picker-cell-range-end
    .ant-picker-cell-inner {
    background: #0a72d8;
    color: #fff;
  }
  .hotel-date-popup
    .ant-picker-cell-in-view.ant-picker-cell-in-range
    .ant-picker-cell-inner,
  .hotel-range-popup
    .ant-picker-cell-in-view.ant-picker-cell-in-range
    .ant-picker-cell-inner {
    background: rgba(10, 114, 216, 0.15);
    color: #111827;
  }

  .field-icon-lg {
    font-size: 22px;
    color: #0b0b0b;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .occupancy-shell {
    cursor: pointer;
    user-select: none;
    gap: 10px;
  }

  .occupancy-label {
    flex: 1;
    font-size: 13px;
    font-weight: 500;
    color: #111827;
  }

  .dropdown-icon {
    color: #111827;
    font-size: 14px;
  }

  .search-button {
    height: 44px;
    min-width: 220px;
    padding: 0 22px;
    border-radius: 8px;
    background: var(--pou-search-btn, #8db906);
    border: 1px solid var(--pou-search-btn, #8db906);
    color: #fff !important;
    font-size: 15px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-shadow: 0 12px 28px rgba(0, 103, 207, 0.25);
    transition:
      background 0.2s ease,
      transform 0.2s ease;
    &:hover {
      background: #0f6bc5;
      transform: translateY(-1px);
    }
  }

  .occupancy-panel {
    width: 320px;
    padding: 14px;
    background: #fff;
    border: 1px solid #d7d8dd;
    border-radius: 10px;
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.18);
  }

  .occ-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .occ-label {
    font-weight: 700;
    color: #0f172a;
  }

  .counter {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .counter-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #cdd3dd;
    background: #f7f9fc;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1;
    cursor: pointer;
  }

  .counter-value {
    min-width: 22px;
    text-align: center;
    font-weight: 700;
    color: #0f172a;
  }

  .occupancy-info {
    font-size: 12px;
    line-height: 1.5;
    color: #4b5563;
    margin: 6px 0 14px;
  }

  .done-btn {
    height: 40px;
    border-radius: 8px;
    font-weight: 700;
    color: #0a72d8;
    border: 1px solid #0a72d8;
    background: #ffffff;
  }

  @media (max-width: 900px) {
    .search-row {
      flex-direction: column;
    }
    .input-shell,
    .search-button {
      width: 100%;
      min-width: 100%;
    }
    .search-button {
      font-size: 18px;
    }
  }

  @media (max-width: 600px) {
    padding: 12px;
    .input-shell {
      height: 72px;
      padding: 0 18px;
      border-radius: 12px;
    }
    .input-shell .ant-picker-input > input {
      font-size: 13px;
    }
    .field-icon-lg {
      font-size: 22px;
      padding: 8px 0;
    }
    .search-button {
      height: 50px;
      font-size: 20px;
    }
    .hotel-range-popup .ant-picker-panel-container {
      width: 100vw;
      max-width: 100%;
      border-radius: 0 0 14px 14px;
    }
    .hotel-range-popup .ant-picker-panels {
      flex-direction: column;
      gap: 8px;
    }
    .hotel-range-popup .ant-picker-panel {
      width: 100% !important;
      border-left: none;
    }
  }
`;

export const HotelPriceListWrapper = styled.div`
  margin: 12px auto 20px;
  max-width: 1200px;
  background: #fff;
  border: 1px solid var(--pou-card-border, #e2e5ed);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 44, 92, 0.08);
  padding: 16px;
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #868686;
  }
  .hotelPriceList {
    &-fields {
      margin: 0px auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 500px;
      .ant-form-item {
        margin-bottom: 7px;
      }
    }
    &-price {
      display: flex;
      flex-direction: column;
      &-no-discount {
        color: red;
        text-decoration: line-through;
      }
    }
    &-minStay {
      font-size: 12px;
      color: #d93025;
      font-weight: 600;
      margin-top: 4px;
    }
    &-roomStatus {
      font-size: 12px;
      color: #d93025;
      font-weight: 600;
      margin-top: 6px;
    }
    &-onRequest {
      font-size: 12px;
      color: #b45309;
      font-weight: 600;
      margin-top: 6px;
    }
    &-early-discount {
      font-size: 13px;
      font-weight: 700;
      margin-top: 4px;
      background: #0a72d8;
      color: #fff;
      border-radius: 8px;
      padding: 4px 14px;
      min-width: 220px;
    }
    &-day-extras {
      margin-top: 6px;
      font-size: 12px;
      color: #0a72d8;
    }
    &-day-extra {
      line-height: 1.4;
      margin-top: 4px;
    }
    &-roomCol {
      align-content: flex-start;
    }
    &-promo-image {
      width: 160px;
      max-width: 100%;
      margin-top: 10px;
      display: block;
    }
  }
  .meta-highlight {
    color: var(--pou-warning-red, #d93025);
    font-weight: 500;
    margin-top: 4px;
  }
  .price-amounts {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .price-amount {
    font-size: 16px;
    font-weight: 700;
    color: var(--pou-text-main, #202634);
    &.selling {
      font-size: 12px;
      font-weight: 600;
      color: var(--pou-warning-red, #d93025);
      text-decoration: line-through;
      text-decoration-color: #d93025;
    }
  }
`;
export const MealPriceSelectionWrapper = styled.div`
  .mealPriceSelection {
    &-include {
      color: green;
    }
    &-policy {
      margin-top: 5px;
      color: green;
      font-size: 12px;
      &[data-non-refundable="true"] {
        color: var(--pou-warning-red, #d93025);
      }
    }
    &-payment {
      margin-top: 10px;
      color: #38a7cd;
      font-size: 12px;
      font-weight: 700;
    }
  }
`;

export const HotelCartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .HotelCart {
    &-title {
      color: #005fc3;
      font-size: 18px;
      font-weight: 700;
      padding: 15px;
      font-family: "Roboto";
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #eee;
    }
    &-body {
      padding: 0 15px;
    }
    &-noRoom {
      font-size: 18px;
      font-weight: 700;
      width: 100%;
      text-align: center;
      padding: 20px;
      color: #aaaaaa;
      margin-top: 50px;
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
`;
export const HotelRoomCartItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-top: 1px solid #ccc;
  margin: 10px 0;
  background-color: #fff;
  position: relative;
  .HotelRoomCartItem {
    &-roomNumber {
      font-size: 14px;
      padding-right: 5px;
    }
    &-name {
      font-size: 13px;
      width: 150px;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &-price {
      font-size: 16px;
    }
    &-mealType {
      font-size: 13px;
      color: #333;
      margin-top: 6px;
      font-weight: 400;
    }
    &-refundable {
      font-size: 13px;
      color: #2472ca;
      &[data-non-refundable="true"] {
        color: var(--pou-warning-red, #d93025);
      }
    }
    &-guest {
      font-size: 14px;
      &-child {
        font-size: 11px;
      }
    }
    &-remove {
      position: absolute;
      top: 10px;
      right: 10px;
      color: #eb5a5a;
    }
  }
`;
export const PeriodBoxWrapper = styled.div`
  min-width: 170px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  cursor: pointer;
  padding: 10px 14px;
  border: 1px solid #d6deea;
  border-radius: 12px;
  background: #f7fafc;
  transition: all 0.2s ease;
  &:hover {
    background-color: #e7f1fd;
    border-color: #0a72d8;
  }
  .PeriodBox {
    &-title {
      color: #0a72d8;
      font-size: 13px;
      font-weight: 700;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 120px;
    }
    &-body {
      display: flex;
      flex-direction: column;
      line-height: 1.2;
    }
    &-des {
      color: #5f6e87;
      font-family: "Avenir";
    }
    &-mine {
      color: #0a72d8;
      font-weight: 700;
    }
    &-select {
      display: none;
    }
  }
`;

export const HotelRoomInfoWrapper = styled.div`
  width: 300px;
  .HotelRoomInfo {
    &-title {
      color: #005fc3;
      font-size: 16px;
      font-weight: 700;
      padding: 10px 0 0px;
      font-family: "Roboto";
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-squareMeters {
      font-size: 14px;
      color: #5f6e87;
      font-family: "Avenir";
    }
    &-amenities {
      border-top: 1px solid #eee;
      padding-top: 15px;
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      @media only screen and (max-width: 600px) {
        display: none;
      }
      .ant-tag {
        display: block;
        background-color: #229cff13;
        color: #118fe9;
        border: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .amenities-toggle {
        background-color: #ffe8c2;
        color: #c25a00;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
`;

export const HotelRequestFormWrapper = styled.div`
  margin: 20px 20px;
  max-width: 500px;
  width: 100%;
  margin: 20px auto;
  background-color: #dbe4eb;
  padding: 20px;
  border: 1px solid #dbe4eb;
  .request-form {
    text-align: left;
    &-title {
      font-size: 18px;
      font-weight: 700;
    }
    &-sub-title {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
`;
